"use strict";
/*

普通模式：开发者通过传入对象 我们去localstorage找同名key，如果找到把那个变量替换返回回去给开发者使用
如果没有，啥也不做，把开发者设定的变量返回回去

debug模式：如果开发者通过debug表单写入配置，写入到localstorage，这里需要一个表单，刷新页面后就同上步骤(去localstorage找同名key，如果找到把那个变量替换返回回去给开发者使用)
这里表单逻辑需要商榷，如果有某种一次性编辑几个表单的是不是交由开发者自己刷新？

理论加载优先级最高

keyword：类型检测, 支持多表单配置

*/
Object.defineProperty(exports, "__esModule", { value: true });
// Polyfill of Object.assign
if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) {
            'use strict';
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }
            var to = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];
                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}
function createConfig(namespace, defaultConfig) {
    var _config = new Config({ key: namespace, variables: defaultConfig });
    return _config.UserConfig.variables;
}
exports.createConfig = createConfig;
var Config = /** @class */ (function () {
    function Config(UserConfig) {
        this.UserConfig = UserConfig;
        if (Config.GetQueryStringFromUrl('debug') === 'true') {
            window.localStorage.setItem('Config/debug', 'true');
        }
        if (Config.GetQueryStringFromUrl('debug') === 'false') {
            window.localStorage.setItem('Config/debug', 'false');
        }
        if (window.localStorage.getItem('Config/debug') && window.localStorage.getItem('Config/debug') === 'true') {
            this.debugModeHandle(); // debug
        }
        else {
            this.normalModeHandle(); // 普通模式
        }
    }
    Config.GetQueryStringFromUrl = function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = decodeURI(window.location.search.substr(1)).match(reg);
        if (r != null)
            return unescape(r[2]);
        return null;
    };
    // 普通模式handle
    Config.prototype.normalModeHandle = function () {
        var getUserVariable = this.UserConfig.variables;
        var tmpConf = {};
        var UserKey = this.UserConfig.key;
        for (var i in getUserVariable) {
            if (localStorage.getItem("Config/" + UserKey + "/" + i) && localStorage.getItem("Config/" + UserKey + "/" + i) !== null) {
                tmpConf[i] = localStorage.getItem("Config/" + UserKey + "/" + i);
            }
        }
        var mergeVariable = Object.assign(getUserVariable, tmpConf);
        return mergeVariable;
    };
    // debug模式handle
    Config.prototype.debugModeHandle = function () {
        var _this = this;
        this.mergeInsertVariable();
        // 塞一个大dom固定在最下面，配置的按钮就可以塞里面了
        setTimeout(function () {
            if (!document.querySelector('.confArea')) {
                var newDiv = document.createElement('div');
                newDiv.className = 'confArea';
                newDiv.style.position = 'fixed';
                newDiv.style.bottom = 50 + 'px';
                newDiv.style.width = 200 + 'px';
                document.body.appendChild(newDiv);
            }
            _this.initConfigBtn(_this.UserConfig.key);
        }, 3500);
    };
    // ui 
    Config.prototype.initConfigBtn = function (btnPostfix) {
        var _this = this;
        var button = "<button id=\"btn_" + btnPostfix + "\" width: 70px; outline: none; z-index: 9999\">" + btnPostfix + "\u53C2\u6570\u914D\u7F6E</button>";
        document.querySelector('.confArea').insertAdjacentHTML('beforeend', button);
        document.querySelector("#btn_" + btnPostfix).addEventListener('click', function () {
            _this.initConfigForm();
        });
    };
    Config.prototype.mergeInsertVariable = function () {
        var getUserVariable = this.UserConfig.variables;
        var tmpConf = {};
        var UserKey = this.UserConfig.key;
        for (var i in getUserVariable) {
            if (localStorage.getItem("Config/" + UserKey + "/" + i) && localStorage.getItem("Config/" + UserKey + "/" + i) !== null) {
                tmpConf[i] = localStorage.getItem("Config/" + UserKey + "/" + i);
            }
        }
        var mergeVariable = Object.assign(getUserVariable, tmpConf);
        return mergeVariable;
    };
    Config.prototype.initConfigForm = function () {
        var _this = this;
        var getVariable = this.mergeInsertVariable();
        var getVariableKeys = [];
        var getVariableValues = [];
        for (var i in getVariable) {
            getVariableKeys.push(i);
            getVariableValues.push(getVariable[i]);
        }
        var childDom = document.querySelector('.configForm');
        if (childDom) {
            document.body.removeChild(childDom);
        }
        var configForm = "<div class=\"configForm\" style=\"position: fixed;\n         top: 50%;\n         left: 50%;\n         background: #fff;\n         padding: 16px;\n         width: 250px;\n         z-Index: 100;\n         border-radius: 10px;\n         transform: translate(-50%, -50%);\">\n         <div class=\"testConfigFormWrap\">\n            <div class=\"typeConfigInfo\">\n            " + getVariableValues.map(function (v, index) {
            return "<span style=\"display: block\">" + getVariableKeys[index] + ":</span>\n               <input \n                class=" + _this.UserConfig.key + "_" + getVariableKeys[index] + "\n                style=\"margin-bottom: 5px;\n                margin-top: 5px;\n                border: 1px solid #000000;\n                width: 200px;\" id=" + getVariableKeys[index] + " type=\"text\"/>\n                <button class=\"deleteItem\" data-item=" + getVariableKeys[index] + ">\u6E05\u9664</button>";
        }).join('') + "                \n            </div>    \n            <div class=\"submitBtn\" style=\"display: flex;\n                justify-content: space-evenly;\n                margin-top: 12px;\">\n                    <button id=\"modificationBtn\">\u786E\u5B9A</button>\n                    <button id=\"cancelConfigBtn\">\u53D6\u6D88</button>\n                    <button id=\"recoverConfigBtn\">\u6062\u590D\u9ED8\u8BA4\u914D\u7F6E</button>\n            </div>\n        </div>";
        document.body.insertAdjacentHTML('beforeend', configForm);
        // 绑定删除事件
        document.querySelector('.typeConfigInfo').addEventListener('click', function (ev) {
            var target = ev.target || ev.srcElement;
            if (target !== null && target.nodeName.toLowerCase() == 'button') {
                if (target.className === 'deleteItem') {
                    document.querySelector("." + _this.UserConfig.key + "_" + target.dataset.item).value = '';
                    localStorage.removeItem("Config/" + _this.UserConfig.key + "/" + target.dataset.item);
                }
            }
        });
        // 绑定取消按钮事件
        document.querySelector('#cancelConfigBtn').addEventListener('click', function () {
            _this.cancelConfigBtn();
        });
        // 绑定确认修改按钮事件
        document.querySelector('#modificationBtn').addEventListener('click', function () {
            _this.modificationBtn();
        });
        // 绑定恢复默认设置按钮事件
        document.querySelector('#recoverConfigBtn').addEventListener('click', function () {
            _this.recoverConfigBtn();
        });
    };
    // 取消按钮事件
    Config.prototype.cancelConfigBtn = function () {
        document.body.removeChild(document.querySelector('.configForm'));
    };
    // 确认修改
    Config.prototype.modificationBtn = function () {
        var childNodes = document.querySelector('.typeConfigInfo').children;
        for (var i = 0; i < childNodes.length; i++) {
            if (childNodes[i].nodeName === 'INPUT') {
                if (childNodes[i].value.length > 0) {
                    window.localStorage.setItem("Config/" + this.UserConfig.key + "/" + childNodes[i].id, childNodes[i].value);
                }
            }
        }
        document.body.removeChild(document.querySelector('.configForm'));
        setTimeout(function () {
            alert('当前表单配置信息已修改，刷新后生效');
            window.location.reload();
        }, 500);
    };
    // 恢复默认设置
    Config.prototype.recoverConfigBtn = function () {
        var _this = this;
        Object.getOwnPropertyNames(localStorage).filter(function (key) { return key.indexOf("Config/" + _this.UserConfig.key + "/") > -1
            ? localStorage.removeItem(key)
            : void (0); });
        setTimeout(function () {
            alert('当前表单配置信息已恢复默认，刷新后生效');
            window.location.reload();
        }, 500);
    };
    return Config;
}());
